import React from 'react'

import { Html } from '@application/Interfaces/Atoms/Html'
import { Link } from '@application/Interfaces/Features/StaticTradelane/StaticTradelane.styled'
import { SingleTitleDescriptionCTAType } from '@application/Types/ComponentTypes'
import { Grid } from '@icontainers/design-system/dist/atoms/Grid'
import { Button } from '@icontainers/design-system/dist/molecules/Button'
import Container from '@mui/material/Container'

import { Description, Title, Wrapper } from './SingleTitleDescriptionCTA.styled'

export const SingleTitleDescriptionCTA = ({
    title,
    description,
    buttonLabel,
    buttonLink,
    mode,
}: SingleTitleDescriptionCTAType): JSX.Element => {
    return (
        <Wrapper $mode={mode}>
            <Container>
                <Grid container justifyContent="center" textAlign="center">
                    <Grid item xs={12} md={9}>
                        <Title>{title}</Title>
                        {description && (
                            <Description>
                                <Html content={description?.data.childMarkdownRemark.html as string} />
                            </Description>
                        )}
                        <Link to={buttonLink}>
                            <Button>{buttonLabel}</Button>
                        </Link>
                    </Grid>
                </Grid>
            </Container>
        </Wrapper>
    )
}
